import React from "react";
import CrudManager from "../../../../components/common/CrudManager";
import { faTable } from "@fortawesome/free-solid-svg-icons";

// Joins that duplicate the header row once per joined child row (e.g. one row
// per sales line). When a value here is true, CrudManager groups those rows
// back into a single visual row by default (see table-config.yml
// joins.<key>.frontend.groupDuplicateRows). Users can still toggle this from
// the grid UI; their choice is persisted per-user and overrides this default.
const JOIN_ROW_GROUPING_DEFAULTS = {};

const CommissionSalesGroupsPageGen = ({ service, transformColumns, crudConfigOverride }) => {
  const formTabs = [{"tabId": "general", "label": "axFormLayout.commissionsalesgroup.tabs.general", "order": 1, "groups": [], "fields": ["groupid", "name"]}];

  const baseColumns = [
    {
      key: "groupid",
      label: "commissionSalesGroups.groupId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: false,
      disabled: true,
      type: "text"    },
    {
      key: "name",
      label: "commissionSalesGroups.name",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: true,
      showInForm: true,
      showInFilter: true,
      editable: true,
      disabled: false,
      type: "text"    },
    {
      key: "modifieddate",
      label: "commissionSalesGroups.modifieddate",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: false,
      editable: false,
      disabled: false,
      type: "datetime",
      filterType: "date"    },
    {
      key: "dataAreaId",
      label: "commissionSalesGroups.dataAreaId",
      fieldPermissionControlled: true,
      sortable: true,
      showInGrid: false,
      showInForm: false,
      showInFilter: true,
      editable: false,
      disabled: false,
      type: "text"    },
  ];

  const columns = transformColumns ? transformColumns(baseColumns) : baseColumns;
  const initialFormData = columns.reduce((acc, col) => {
    if (
      col &&
      col.showInForm &&
      Object.prototype.hasOwnProperty.call(col, "defaultValue")
    ) {
      acc[col.key] = col.defaultValue;
    }
    return acc;
  }, {});

  const defaultCrudConfig = {
    canCreate: true,
    canEdit: true,
    canDelete: true
  };

  const crudConfig = {
    ...defaultCrudConfig,
    ...(crudConfigOverride || {})
  };

  return (
    <CrudManager
      service={service}
      columns={columns}
      entityName="commissionSalesGroups"
      permissionPrefix="legacy.commissionSalesGroups"
      icon={faTable}
      formLayout="modal"
      canCreate={crudConfig.canCreate}
      canEdit={crudConfig.canEdit}
      canDelete={crudConfig.canDelete}
      initialFilters={crudConfig.initialFilters || {}}
      initialSort={crudConfig.initialSort || null}
      gridRowStyleResolver={crudConfig.gridRowStyleResolver || null}
      joinRowGroupingDefaults={JOIN_ROW_GROUPING_DEFAULTS}
      renderForm={crudConfig.renderForm || null}
      modalClassName={crudConfig.modalClassName || ""}
      formTabs={formTabs}
      initialFormData={initialFormData}
    />
  );
};

export default CommissionSalesGroupsPageGen;